(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(document).ready(function () {
            function openTourCallback(tourId) {
                var event = new CustomEvent('hotel:show-tour-callback', {
                    detail: {
                        tourId: tourId
                    }
                });
                document.body.dispatchEvent(event);
            }

            // Переход к экрану "Купить у менеджера"
            $('#tour-promo-app-popup').on('click', '.js-tour-promo-app', function () {
                window.brxTracking.sendAnalyticsEvent('tour-details-app');
            }).on('click', '.js-tour-promo-app-show-manager', function () {
                window.brxTracking.sendAnalyticsEvent('tour-details-manager');

                var tourId = this.dataset.tourId;

                var $managerStep = $('.tour-promo-manager');
                var $appStep = $('.tour-promo-app');
                // toggle
                $appStep.removeClass('visible');
                $managerStep.addClass('visible');
                // back to top
                $managerStep.scrollParent().scrollTop(0);
                window.getShortIdByRealId(tourId, '#tour-promo-app-popup .replace-with-short-tour-id');
                window.brxTracking.callTrackingRefresh();
            })
            // Изменение города при просмотре контактов
            .on('change', '.js-tour-promo-city-select', function () {
                var $input = $(this);
                var city = window.CityItemSearch.findById($input.val());
                if (city) {
                    // Изменяет контакты на экране "Купить у менеджера"
                    var $parent = $input.closest('.tour-promo-contacts');
                    var $phone = $parent.find('.tour-promo-phone-button');
                    var phoneItem = city.getPhoneItem('alt');
                    city.changePhoneLink($phone[0], phoneItem);
                }
            }).on('click', '.tour-promo-callback-button', function () {
                var tourId = this.dataset.tourId;
                var $parentModal = $(this).closest('.mpopup');
                if ($parentModal.length) {
                    window.close_popup('#' + $parentModal.attr('id'), function () {
                        openTourCallback(tourId);
                    });
                } else {
                    openTourCallback(tourId);
                }
            });
        });
    }, {}] }, {}, [1]);